import { caseCategories } from "@/mocks/cases";

interface CaseToolbarProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
  keyword: string;
  onKeywordChange: (keyword: string) => void;
  resultCount: number;
}

export default function CaseToolbar({
  activeCategory,
  onCategoryChange,
  keyword,
  onKeywordChange,
  resultCount,
}: CaseToolbarProps) {
  return (
    <div className="mt-6 md:mt-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-wrap gap-2 p-1 rounded-full bg-background-50 border border-background-200 w-fit max-w-full">
          {caseCategories.map((category) => {
            const isActive = activeCategory === category;
            return (
              <button
                key={category}
                type="button"
                onClick={() => onCategoryChange(category)}
                aria-pressed={isActive}
                className={`px-4 py-1.5 rounded-full text-xs md:text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-200"
                }`}
              >
                {category}
              </button>
            );
          })}
        </div>

        <div className="relative w-full lg:w-72 shrink-0">
          <i
            className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base"
            aria-hidden="true"
          ></i>
          <input
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder="搜索档案标题或关键词"
            aria-label="搜索调查档案"
            className="form-field w-full pl-10 pr-4 py-2.5 rounded-md text-sm bg-background-50 border border-background-200 text-foreground-900 placeholder:text-foreground-400"
          />
        </div>
      </div>

      <p className="mt-4 text-xs md:text-sm text-foreground-500">
        当前筛选出 <strong className="font-semibold text-primary-600">{resultCount}</strong> 份档案
        {activeCategory !== "全部" && ` · 主题「${activeCategory}」`}
      </p>
    </div>
  );
}